<li #rla="routerLinkActive"
    [ngClass]="{ minimized: isMinimized() }"
    [routerLinkActive]="['active']"
    class="list__item">
  <a
    #trigger2="cdkOverlayOrigin"
    (mouseenter)="onMouseEnterInLink()"
    (mouseleave)="closeSubItemsPopup()"
    [class.open]="subItemsPopupOpen()"
    [ngClass]="{ minimized: isMinimized() }"
    [routerLinkActive]="['active']"
    [routerLink]="listItem().url"
    cdkOverlayOrigin
  >
    <div class="list__icon">
      <app-icon [color]="getColorIcon(rla)" [iconName]="listItem().icon"/>
    </div>
    @if (!isMinimized()) {
      <span [routerLinkActive]="['active']" class="list__title">
        {{ listItem().header | translate }}
      </span>
    }
  </a>
</li>

<ng-template
  (overlayOutsideClick)="closeSubItemsPopup()"
  [cdkConnectedOverlayHasBackdrop]="false"
  [cdkConnectedOverlayOpen]="subItemsPopupOpen()"
  [cdkConnectedOverlayOrigin]="trigger2"
  [cdkConnectedOverlayPanelClass]="'nav-popup-pane'"
  [cdkConnectedOverlayPositions]="positions"
  [cdkConnectedOverlayPush]="true"
  [cdkConnectedOverlayViewportMargin]="10"
  cdkConnectedOverlay
>

  <div @popup2>
    <app-popup-minimized-nav-bar [titleSubItems]="listItem().header"/>
  </div>
</ng-template>
